(function () {
    "use strict";

    // @ngInject
    function ReportsFeesControllerCtor($scope, $injector, AppConfigService, ReportsManager) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ReportsFeesController';

        var self = this;
        var reportState = AppConfigService.reportsState();
        this.loadingReports = false;

        if (!reportState.fees) {

            reportState.fees = [];
            this.fees = reportState.fees;

            this.loadingReports = true;
            ReportsManager.getReportsFees().then(
                function success(resp) {
                    self.loadingReports = false;
                    angular.copy(resp.data, reportState.fees);
                    self.initialize();
                },

                function error(resp) {
                    self.loadingReports = false;
                    self.lastError = resp.data.error_message || resp.data;
                }
            )
        } else {
            this.fees = reportState.fees;
            this.initialize();
        }

    }


    Controllers.ReportsFeesController = Class(Controllers.BaseController, {

        constructor: ReportsFeesControllerCtor,

        initialize: function initialize(){
            this.feesPeriods = this.fees;
        }

    });
}());
